import { render } from "./FormManterCalculoExercicio.vue?vue&type=template&id=c4a631d8"
import script from "./FormManterCalculoExercicio.vue?vue&type=script&lang=js"
export * from "./FormManterCalculoExercicio.vue?vue&type=script&lang=js"

import "./FormManterCalculoExercicio.vue?vue&type=style&index=0&id=c4a631d8&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__